import { ValidateEventFxn } from 'common.types'
import {
  FailureScreen,
  SuccessScreen,
} from 'views/forms/status-lookup/components'
import { globalStore } from '../../../../stores/GlobalStore'
/**
 *
 * @param step
 * @param apiResponse
 * @param setReplacementContent
 * @returns {boolean} If `true`, then form continues to next step
 */
const validateLookupStatusEvent: ValidateEventFxn = (
  step,
  apiResponse,
  setReplacementContent,
  setState,
) => {
  const { serverResponse } = apiResponse
  const setSuccessFlag = (flag: boolean) => {
    const globalState = globalStore?.state
    globalStore.setState({
      ...globalState,
      formEvents: {
        ...(globalState.formEvents ?? {}),
        registeredStatusLookupSuccess: flag,
      },
    })
  }
  if (step === 1) {
    if (
      serverResponse?.data?.data?.length === 1 &&
      serverResponse.data.data[0].status === 'A'
    ) {
      const matchedVoter = serverResponse.data.data[0]
      const {
        residentialAddressStreet,
        residentialAddressNumber,
        residentialAddressZip,
        residentialAddressUnit,
        residentialAddressCity,
        county,
        firstName,
        lastName,
      } = matchedVoter
      setState((prevState) => ({
        ...prevState,
        matchedVoter,
      }))
      const toTitleCase = (str: string) => {
        return str.replace(
          /\w\S*/g,
          (text) =>
            text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
        )
      }

      const globalState = globalStore?.state
      globalStore.setState({
        ...globalState,
        sharedUserInputValues: {
          ...(globalState?.sharedUserInputValues ?? {}),
          address: `${residentialAddressNumber} ${toTitleCase(
            residentialAddressStreet,
          )}`,
          addressTwo: residentialAddressUnit,
          county: toTitleCase(county),
          city: toTitleCase(residentialAddressCity),
          zip: residentialAddressZip,
        },
        formEvents: {
          ...(globalState.formEvents ?? {}),
          registeredStatusLookupSuccess: true,
        },
      })
      setReplacementContent(<SuccessScreen matchedVoter={matchedVoter} />)
      return true
    }
    setSuccessFlag(false)
    setReplacementContent(<FailureScreen />)
    return false
  }
  return true
}
export default validateLookupStatusEvent
